module.exports = __webpack_public_path__ + "static/img/aaaa-3.4c142ceb.png";